export default "__VITE_ASSET__e23b6dde__"